<template>
  <v-container>
    <v-text-field v-model="title" label="Title" />
    <v-text-field v-model.number="years" label="Age" :rules="[rules.number, rules.max]" />
    <v-btn @click="onSave" class="d-flex ml-auto" depressed color="#FF347C" outlined>Save</v-btn>
  </v-container>
</template>
<script>
import { patchTeacher } from "@/api/api";

export default {
  data() {
    return {
      title: "",
      years: 0,
      rules: {
        max: (v) => v < 120 || "Too Old Person",
        number: (v) => {
          return typeof v === "number" || "Must be a number";
        },
      },
    };
  },
  methods: {
    async onSave() {
      const response = await patchTeacher({
        uuid: this.$store.getters["admin/teacher"].uuid,
        body: {
          teacher_profile: {
            title: this.title,
            experience: this.years,
          },
        },
      });
      if (response) this.$emit("teacher-updated", response.data);
    },
    create() {
      this.title = this.teacher.teacher_profile.title;
      this.years = this.teacher.teacher_profile.experience;
    },
  },
  computed: {
    teacher() {
      return this.$store.getters["admin/teacher"];
    },
  },
  watch: {
    "teacher.uuid"() {
      this.create();
    },
  },
  created() {
    this.create();
  },
};
</script>
